import * as React from 'react';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { ScreenPickerProps, ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { SafetyLimitMultiSelect } from 'app/components';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { endpoints } from 'app/area/codetable/item/endpoints';
import { syncSafetyLimits } from './sync-safety-limits';

export interface SafetyLimitAddButtonProps extends ScreenPickerProps {
  existingKeys: CodeComplexValue<number>[];
}

export const SafetyLimitAddButton = (props: SafetyLimitAddButtonProps) => {

  const { updateByKey, 
    loadOptions, options, 
    existingKeys = [], codeItem, translation } = props;

  const onLoadOptions = (loadOptionsParams: LoadOptions) => {
    loadOptions('caseTypes', endpoints.caseType, loadOptionsParams);
  };

  const handleSyncSafetyLimits = (selectedKeys: ComplexValue<number>[]) => {
    updateByKey(ScreenPicker.safetyLimit, syncSafetyLimits(codeItem.safetyLimit || [], selectedKeys));
  };

  const caseTypes = options?.caseTypes;
  const codeOptions = (caseTypes?.codes || []) as CodeComplexValue<number>[];
  const fetching = caseTypes?.fetching;
  const loadOptionsParams = caseTypes?.loadOptionsParams;

  return <SafetyLimitMultiSelect
    fetching={fetching}
    existingKeys={existingKeys}
    onSyncDocumentItems={handleSyncSafetyLimits}
    options={codeOptions}
    textAddItem={translation.add_safety_limit}
    placeholderSearch={translation.search}
    textCodeSelectorTitle={translation.add_safety_limit}
    textDone={translation.done}
    onLoadOptions={onLoadOptions}
    loadOptions={loadOptionsParams}
    displaySelectAll={true}
    canHideSearchInput={false}
  />;
};
